import { ready } from '~/core'
import addEvents from '~/utils/addEvents'
ready('pdf-viewer-cta', '.pdf-viewer-cta', (cta) => {
  if (window.dFlipConfig) {
    let styleUrl = dFlipConfig.styleUrl
    let scriptUrl = dFlipConfig.scriptUrl

    function isPDFScriptLoaded(url) {
      if (!url) return true
      var scripts = document.getElementsByTagName('script')
      for (var i = scripts.length; i--; ) {
        if (scripts[i].src == url) {
          return true
        }
      }
      return false
    }
    function isPDFStyleLoaded(url) {
      if (!url) return true
      var styles = document.getElementsByTagName('link')
      for (var i = styles.length; i--; ) {
        if (styles[i].href == url) {
          return true
        }
      }
      return false
    }

    if (!isPDFStyleLoaded(styleUrl)) {
      var link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = styleUrl
      document.head.appendChild(link)
    }

    if (!isPDFScriptLoaded(scriptUrl)) {
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = scriptUrl
      document.head.appendChild(script)
    }

    if (!cta.classList.contains('_df_custom')) {
      cta.classList.add('_df_custom')
    }

    if (cta.hasAttribute('href') && !cta.hasAttribute('source')) {
      cta.setAttribute('source', cta.getAttribute('href'))
    }

    addEvents(cta, 'click.prevent', (e) => {
      if (DFLIP) {
        DFLIP.defaults.backgroundColor = '#000000b0'
      }
    })
  }
})
